import { ISize } from "./MyHelpers";
import { assertEqual, assertNever } from "./debug";

export type FitType = "none" | "fit" | "stretch";

export interface DoubleUpMiscellaneous{
    readonly ShowLastBigCard: boolean;
}

export type WarningMessage = "malfunction" | "amusement" ;

export enum ScreenConfiguration
{
    SeparateScreens,
    CombinedScreen
}

export const enum JackpotDisplayType
{
    PreciousSpin = "PreciousSpin",
    DiamondPot = "DiamondPot",
    DiamondPotOrtiz = "DiamondPotOrtiz",    
    DragonJackpot = "DragonJackpot",
    DiamondPotStep = "DiamondPotStep",
    DiamondPotCaliente = "DiamondPotCaliente",
    DiamondPotPlayCity = "DiamondPotPlayCity",
    PlayCityLink = "PlayCityLink",
    PlayCityLinkResponsive = "PlayCityLinkResponsive",
    PlayCityLinkResponsivePIXI = "PlayCityLinkResponsivePIXI",
    JubileeLink = "JubileeLink",
    JubileeLinkResponsive = "JubileeLinkResponsive",
    JubileeLinkResponsivePIXI = "JubileeLinkResponsivePIXI",
    DiamondPotJubilee = "DiamondPotJubilee",
    PaytableJackpotDisplay = "PaytableJackpotDisplay",
    ViventoLink = "ViventoLink",
    RapidDiamondPot = "RapidDiamondPot",
    RapidDiamondPot2 = "RapidDiamondPot2",
    RapidDiamondPotStep = "RapidDiamondPotStep",
    RapidDiamondPotFire = "RapidDiamondPotFire",
    DiamondPotRappidFrames = "DiamondPotRappidFrames",    
    DiamondPotStepRappidFrames = "DiamondPotStepRappidFrames",    
    RapidDiamondPotStep2 = "RapidDiamondPotStep2",
    RainbowGirls = "RainbowGirls",
    DiamondPotStepShared = "DiamondPotStepShared",
    DiamondPotStepSinShared = "DiamondPotStepSinShared",
    DiamondPotResponsive = "DiamondPotResponsive",
    DiamondPotResponsivePIXI = "DiamondPotResponsivePIXI",
    DiamondPotResponsivePIXIHorizontal = "DiamondPotResponsivePIXIHorizontal",
    DiamondPotStepRappidFramesSpine = "DiamondPotStepRappidFramesSpine",   
    DiamondPotRappidFramesSpine = "DiamondPotRappidFramesSpine",
    DiamondPotStepSharedSpineV2 = "DiamondPotStepSharedSpineV2",
    DiamondPotStepSinSharedSpineV2 = "DiamondPotStepSinSharedSpineV2", 
    DiamondPotPyramidShared = "DiamondPotPyramidShared",
    DiamondPotPyramidSinShared = "DiamondPotPyramidSinShared",
    DiamondPotPyramidJP4ShareJP3SinShared = "DiamondPotPyramidJP4ShareJP3SinShared",   
    DiamondPotPyramidShared2S = "DiamondPotPyramidShared2S",
    DiamondPotPyramidSinShared2S = "DiamondPotPyramidSinShared2S",
    DiamondPotPyramidJP4SharedJP3SinShared2S = "DiamondPotPyramidJP4SharedJP3SinShared2S",
    DiamondPotPyramidSinSharedResponsive = "DiamondPotPyramidSinSharedResponsive",
    JubileeLinkResponsivePIXIAPPHorizontal = "JubileeLinkResponsivePIXIAPPHorizontal",
    JackpotDisplayPlayCityPIXIAPPHorizontal = "JackpotDisplayPlayCityPIXIAPPHorizontal",
    JackpotDisplayRapidLinkPIXIAPPHorizontal = "JackpotDisplayRapidLinkPIXIAPPHorizontal",
    
}

export enum WallDisplayType
{
    PreciousSpin = "PreciousSpin",
    DiamondPotOrtiz = "DiamondPotOrtiz",
    DiamondPot = "DiamondPot",
    DragonJackpot = "DragonJackpot",
    DiamondPotJubilee = "DiamondPotJubilee",
    DiamondPotCaliente = "DiamondPotCaliente",
    DiamondPotPlayCity = "DiamondPotPlayCity",
    JubileeLink = "JubileeLink",
    ViventoLink = "ViventoLink",
    FirenzeLink = "FirenzeLink",
}

export  enum SourcePickbonus
{
    Ortiz = "Ortiz",
    DragonLink = "DragonLink"
}

export enum JackpotDisplay
{
    Enable = "Enable",
    Disable = "Disable"
}

export enum MenuType{
    OrtizMenu = "OrtizMenu",
    JubileeMenu = "JubileeMenu",
    PyramidMenu = "PyramidMenu",
    DummyMenu = "DummyMenu",
    CalienteMenu = "CalienteMenu",
    PlayCityLinkMenu = "PlayCityLinkMenu",
    PlayCityLinkBigMenu = "PlayCityLinkBigMenu",
    ViventoMenu = "ViventoMenu",
    SliderMenu = "SliderMenu",
    BigAnimatedMenu = "BigAnimatedMenu",
    ClassicMenu = "ClassicMenu",
    EternalFortuneMenu = "EternalFortuneMenu",
    BigAnimatedMysticMenu = "BigAnimatedMysticMenu",
    MysticMenu = "MysticMenu",
    BigAnimatedAsianMenu = "BigAnimatedAsianMenu",
    BigAnimatedMenuPurple = "BigAnimatedMenuPurple",
    ScrollingMenu = "ScrollingMenu",
    InGameMenu = "InGameMenu",
}

export enum PanelType
{
    DefaultBluePanel = "DefaultBluePanel",
    DefaultTransparentPanel = "DefaultTransparentPanel",
    Pyramid = "Pyramid",
    Online = "Online",
    OnlineResponsive = "OnlineResponsive",
    // Online2 = "Online2",
    OnlineMoney = "OnlineMoney",
    OnlineGamesMenu = "OnlineGamesMenu",
    OnlineJubilee = "OnlineJubilee",
    BluePanelSingleGame = "BluePanelSingleGame",
    DefaultGameColorPanel = "DefaultGameColorPanel",
    OnlineResponsive5buttons ="PanelOnlineResponsive5buttons",
    OnlineResponsive5buttons1Line = "OnlineResponsive5buttons1Line",
    Ortiz = "Ortiz"
    //OnlineJubilee = "OnlineJubilee",
}

// export enum LanguageInit
// {
//     SpanishTranslation,
//     EnglishTranslation,
//     RomanianTranslation,
// }
/*** transicion and presentation type :
 * VideoGameSprite= VideoGame+SpriteBonus,
 * Img:Image GameBackground ,
 * VideoCommonNoSprite = VideoCommonNoSprite its commonVideo
 * VideoCommonClassic= VideoComon + SpriteBonus ,     */

export enum Presentation {
    VideoGameSprite = "VideoGameSprite",
    Image = "Image",
    VideoCommonNoSprite = "VideoCommonNoSprite",
    VideoCommonClassic = "VideoCommonClassic",
    VideoNoSprite = "VideoNoSprite",
    VideoParticleTransitionMatterJS = "VideoParticleTransitionMatterJS",
    VideoParticleTransitionFadeInFadeOut = "VideoParticleTransitionFadeInFadeOut",
    VideoParticleTransitionFadeInFadeOutResponsive = "VideoParticleTransitionFadeInFadeOutResponsive",
    JackpotTransitionSpineAnimationResponsive = "JackpotTransitionSpineAnimationResponsive"
}

export enum DisplayAmount
{
    AsCredits = "AsCredits",
    AsMoney = "AsMoney"
}

/** enable or disable virtual bottonera */
export enum VirtualBotoneraType{
    BigButtons = "BigButtons",
    Disable = "Disable",
}

/*** small sliders for info game on GameScreen2  for slot whit 3 and 2 screens */ 
export enum InfoScreenSlider{
    EnableScreen3 ="EnableScreen3",
    EnableScreen2 ="EnableScreen2",
    //Enable ="Enable",
    Disable ="Disable",
    //FillingPotFeature = "FillingPotFeature",
}

export enum TitleGameSlide{
    Enable = "Enable",
    Disable = "Disable",
}

export enum WinLinesType{
    WinLinesAnimation = "WinLinesAnimation",
    WinSquareAnimations = "WinSquareAnimations",
    WinSquareMarkesAnimations = "WinSquareMarkesAnimations",
    WinNumberLinesAnimation = "WinNumberLinesAnimation",
    WinSquare1MarkeAnimations = "WinSquare1MarkeAnimations",    
}

/*** change how will looks GameScreen3 or JackpotScreen for slot whit 3Screen   */ 
export enum Screen3SettingDisplay{
    JackpotDisplay,
    GameTitleJackpot,
}

export enum FillingPotFeature {
    Enable,    
    Disable,
}

export type ScreenHeightType = 1080 | 720 | 540 | 608;
export type ScreenWidthType  = 1920 | 1280 | 960 | 1080;

export enum CometStyles
{
    PurpleStyle = "PurpleStyle",
    BlueStyle = "BlueStyle",
    PurpleStylePIXI = "PurpleStylePIXI",
    BlueStylePIXI = "BlueStylePIXI",
    BlueStylePIXIResponsive = "BlueStylePIXIResponsive",
    Spine="Spine"
}
 
export interface ISettings extends DoubleUpMiscellaneous
{
    readonly ShowLastBigCard: boolean;
    readonly SettingsName: string;

    readonly ScreenConfiguration: ScreenConfiguration;
    readonly JackpotDisplayType: JackpotDisplayType;
    readonly MenuType : MenuType;
    readonly PanelType: PanelType;
	
    readonly Screens: number;
	readonly ScreenHeight: ScreenHeightType;
	readonly ScreenWidth: ScreenWidthType;
    readonly SourcePick: SourcePickbonus;
    
    readonly WallDisplayType: WallDisplayType;
    readonly WallDisplayScreens: number;
    readonly WallDisplaySize: ISize;

	readonly ResourcesFolder: string;
	readonly SpriteFrameDebugging: boolean;
    readonly ConsoleLogging: boolean;

    readonly OnlineControls: boolean;
    readonly EndlessFitting: boolean;
    readonly KeyboardEnabled: boolean;
    readonly PresentationType : Presentation;

    readonly EnablePanelWithSettings: boolean;

    readonly DisplayAmount: DisplayAmount;

    readonly JackpotDisplay: JackpotDisplay;
    readonly VirtualBotoneraType: VirtualBotoneraType;

    readonly JackpotSlider: InfoScreenSlider;
    readonly bottoneraFakeSize: ISize;
    readonly bottoneraRealSize: ISize;

    readonly FailOnConnectionLost: boolean;

    readonly Server: string | (() => string);

    // readonly PayoutButtonEnabled : boolean;
    readonly touchToStop : boolean;

    readonly titleGameSlide : boolean ;
    readonly winLinesType : WinLinesType;
    readonly videoFormat: ".webm" | ".mp4";
    readonly DefaultFitType: FitType;
    readonly audioFormat: ".ogg" | ".mp3";
    readonly warningMessage: WarningMessage;
    readonly skipCommet: boolean;
    readonly screen3Display : Screen3SettingDisplay;
    readonly fillingPotFeature : FillingPotFeature;

    readonly menuGameSelectPresentation: boolean;

    /** change the resources for bonusWin Show Extendend and spinAndHold */
    readonly cometStyle : CometStyles; 

    readonly autoPlaySkipWinLines : boolean;
    readonly Enable2plus1: boolean;
    readonly PauseBackgroundSound : boolean;
    readonly ShowMinBetInfo: boolean;
}

class Settings_Default implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_Default";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPot
    public readonly MenuType : MenuType = MenuType.EternalFortuneMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 1;
	public readonly ScreenHeight: ScreenHeightType = 1080;
	public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/resources-original/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = false;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoGameSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen3;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false
}

class Settings_Online implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly fillingPotFeature: FillingPotFeature = FillingPotFeature.Disable;
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines: boolean = false;
    public readonly SettingsName: string = "Settings_Online";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.JubileeLink;
    public readonly MenuType : MenuType = MenuType.DummyMenu;
    public readonly PanelType: PanelType = PanelType.Online;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 1;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DragonJackpot
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly EnablePanelWithSettings = false;
	//public readonly ResourcesFolder: string = "./static/online-dragon-960x540/";
    public readonly ResourcesFolder: string = "https://usc1.contabostorage.com/0fe075d87e7e4bb9a28324b884177cb2:resources/onlinetest/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = false;

    public readonly OnlineControls: boolean = true;
    public readonly EndlessFitting: boolean = true;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.Image


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    //public readonly Server: string = "{protocol}//{host}/backend/singlegame";
    ///*Local Server*/ public readonly Server: string = "{protocol}//{hostname}:5006";
    ///*Production Server*/
    public readonly Server: string = "{protocol}//{host}";

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "fit";
    public readonly videoFormat = ".mp4";
    public readonly audioFormat = ".mp3";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
}
class DiamondPot implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_Online_DiamondPot";

    public readonly ShowLastBigCard: boolean = false;
    public readonly fillingPotFeature: FillingPotFeature = FillingPotFeature.Disable;
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStylePIXIResponsive;
    public readonly autoPlaySkipWinLines: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotResponsivePIXIHorizontal;
    public readonly MenuType : MenuType = MenuType.DummyMenu;
    public readonly PanelType: PanelType = PanelType.OnlineResponsive5buttons1Line;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 1;
	public readonly ScreenHeight: ScreenHeightType = 540;
	public readonly ScreenWidth: ScreenWidthType = 960;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DragonJackpot
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly EnablePanelWithSettings = false;

	//public readonly ResourcesFolder: string = "./static/online-dragon-960x540/";
    public readonly ResourcesFolder: string = "/frontend-resources/beta/";//"https://usc1.contabostorage.com/0fe075d87e7e4bb9a28324b884177cb2:resources/staging/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = false;

    public readonly OnlineControls: boolean = true;
    public readonly EndlessFitting: boolean = true;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOutResponsive;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    //public readonly Server: string = "{protocol}//{host}/backend/singlegame";
    ///*Local Server*/ public readonly Server: string = "{protocol}//{hostname}:5006";
    ///*Production Server*/ 
    public readonly Server: string = "{protocol}//{host}";

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "fit";
    public readonly videoFormat = ".mp4";
    public readonly audioFormat = ".mp3";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
}

class FillingPot implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_Online_DiamondPot";

    public readonly ShowLastBigCard: boolean = false;
    public readonly fillingPotFeature: FillingPotFeature = FillingPotFeature.Disable;
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStylePIXI;
    public readonly autoPlaySkipWinLines: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotResponsivePIXIHorizontal;
    public readonly MenuType : MenuType = MenuType.DummyMenu;
    public readonly PanelType: PanelType = PanelType.OnlineResponsive5buttons1Line;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 1;
	public readonly ScreenHeight: ScreenHeightType = 540;
	public readonly ScreenWidth: ScreenWidthType = 960;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DragonJackpot
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly EnablePanelWithSettings = false;

	//public readonly ResourcesFolder: string = "./static/online-dragon-960x540/";
    public readonly ResourcesFolder: string = "/frontend-resources/beta/";//"https://usc1.contabostorage.com/0fe075d87e7e4bb9a28324b884177cb2:resources/staging/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = false;

    public readonly OnlineControls: boolean = true;
    public readonly EndlessFitting: boolean = true;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOutResponsive;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    //public readonly Server: string = "{protocol}//{host}/backend/singlegame";
    ///*Local Server*/ public readonly Server: string = "{protocol}//{hostname}:5006";
    ///*Production Server*/ 
    public readonly Server: string = "{protocol}//{host}";

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "fit";
    public readonly videoFormat = ".mp4";
    public readonly audioFormat = ".mp3";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
}
class MultiBonus implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_Online_DiamondPot";

    public readonly ShowLastBigCard: boolean = false;
    public readonly fillingPotFeature: FillingPotFeature = FillingPotFeature.Disable;
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.Spine;
    public readonly autoPlaySkipWinLines: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotPyramidSinSharedResponsive;
    public readonly MenuType : MenuType = MenuType.DummyMenu;
    public readonly PanelType: PanelType = PanelType.OnlineResponsive5buttons1Line;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 1;
	public readonly ScreenHeight: ScreenHeightType = 540;
	public readonly ScreenWidth: ScreenWidthType = 960;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DragonJackpot
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly EnablePanelWithSettings = false;

	//public readonly ResourcesFolder: string = "./static/online-dragon-960x540/";
    public readonly ResourcesFolder: string = "frontend-resources/beta/";//"https://usc1.contabostorage.com/0fe075d87e7e4bb9a28324b884177cb2:resources/staging/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = false;

    public readonly OnlineControls: boolean = true;
    public readonly EndlessFitting: boolean = true;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOutResponsive;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    //public readonly Server: string = "{protocol}//{host}/backend/singlegame";
    ///*Local Server*/ public readonly Server: string = "{protocol}//{hostname}:5006";
    ///*Production Server*/ 
    public readonly Server: string = "{protocol}//{host}";

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "fit";
    public readonly videoFormat = ".mp4";
    public readonly audioFormat = ".mp3";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
}

//settings para RapidLink
class RapidLink implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_Online_RapidLink";

    public readonly ShowLastBigCard: boolean = false;
    public readonly fillingPotFeature: FillingPotFeature = FillingPotFeature.Disable;
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStylePIXIResponsive;
    public readonly autoPlaySkipWinLines: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.JackpotDisplayRapidLinkPIXIAPPHorizontal;
    public readonly MenuType : MenuType = MenuType.DummyMenu;
    public readonly PanelType: PanelType = PanelType.OnlineResponsive5buttons1Line;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 1;
	public readonly ScreenHeight: ScreenHeightType = 540;
	public readonly ScreenWidth: ScreenWidthType = 960;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DragonJackpot
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly EnablePanelWithSettings = false;

	//public readonly ResourcesFolder: string = "./static/online-dragon-960x540/";
    public readonly ResourcesFolder: string = "/frontend-resources/beta/";//"https://usc1.contabostorage.com/0fe075d87e7e4bb9a28324b884177cb2:resources/staging/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = false;

    public readonly OnlineControls: boolean = true;
    public readonly EndlessFitting: boolean = true;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.JackpotTransitionSpineAnimationResponsive;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    //public readonly Server: string = "{protocol}//{host}/backend/singlegame";
    ///*Local Server*/ public readonly Server: string = "{protocol}//{hostname}:5006";
    ///*Production Server*/ 
    public readonly Server: string = "{protocol}//{host}";

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "fit";
    // public readonly videoFormat = ".mp4";
    // public readonly audioFormat = ".mp3";
    public readonly videoFormat = ".mp4";
    public readonly audioFormat = ".mp3";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
}

class Classic implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_Online_Classic";

    public readonly ShowLastBigCard: boolean = false;
    public readonly fillingPotFeature: FillingPotFeature = FillingPotFeature.Disable;
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStylePIXI;
    public readonly autoPlaySkipWinLines: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.PaytableJackpotDisplay;
    public readonly MenuType : MenuType = MenuType.DummyMenu;
    public readonly PanelType: PanelType = PanelType.OnlineResponsive5buttons1Line;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 1;
	public readonly ScreenHeight: ScreenHeightType = 540;
	public readonly ScreenWidth: ScreenWidthType = 960;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DragonJackpot
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly EnablePanelWithSettings = false;

    //public readonly ResourcesFolder: string = "/frontend-resources/beta/";//"https://usc1.contabostorage.com/0767d0a9352c40aaa7861aabdc75d4ec:beta-resources/online-720-fillingPot/";//"https://usc1.contabostorage.com/0fe075d87e7e4bb9a28324b884177cb2:resources/staging/";
    public readonly ResourcesFolder: string = "/frontend-resources/beta/";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = true;
    public readonly EndlessFitting: boolean = true;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.Image;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    //public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;
     //public readonly Server: string = "{protocol}//{host}/backend/singlegame";
    ///*Local Server*/  public readonly Server: string = "{protocol}//{hostname}:5006";
    ///*Production Server*/
    public readonly Server: string = "{protocol}//{host}";

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "fit";
    public readonly videoFormat = ".mp4";
    public readonly audioFormat = ".mp3";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.GameTitleJackpot; 
}

class PlayCity implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = true;
    public readonly ShowLastBigCard: boolean = false;
    public readonly EnablePanelWithSettings: boolean = false;
    public readonly fillingPotFeature: FillingPotFeature = FillingPotFeature.Disable;
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStylePIXI;
    public readonly autoPlaySkipWinLines: boolean = false;
    public readonly Enable2plus1: boolean = false;

    public readonly SettingsName: string = "Settings_Online_PlayCity";

    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.JackpotDisplayPlayCityPIXIAPPHorizontal;
    public readonly MenuType : MenuType = MenuType.PlayCityLinkMenu;
    public readonly PanelType: PanelType = PanelType.OnlineResponsive5buttons1Line;
    
	
    public readonly Screens: number = 1;
	public readonly ScreenHeight: ScreenHeightType = 540;
	public readonly ScreenWidth: ScreenWidthType = 960;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DragonJackpot
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	//public readonly ResourcesFolder: string = "./static/online-dragon-960x540/";
    public readonly ResourcesFolder: string = "/frontend-resources/beta/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = false;

    public readonly OnlineControls: boolean = true;
    public readonly EndlessFitting: boolean = true;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOutResponsive;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    //public readonly Server: string = "{protocol}//{host}/backend/singlegame";
    ///*Local Server*/ public readonly Server: string = "{protocol}//{hostname}:5006";
    ///*Production Server*/ 
    public readonly Server: string = "{protocol}//{host}";

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "fit";
    public readonly videoFormat = ".mp4";
    public readonly audioFormat = ".mp3";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
}

class PlayCityMultiBonus implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = true;
    public readonly ShowLastBigCard: boolean = false;
    public readonly EnablePanelWithSettings: boolean = false;
    public readonly fillingPotFeature: FillingPotFeature = FillingPotFeature.Disable;
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStylePIXI;
    public readonly autoPlaySkipWinLines: boolean = false;
    public readonly Enable2plus1: boolean = false;

    public readonly SettingsName: string = "Settings_Online_PlayCity_MultiBonus";

    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.JackpotDisplayPlayCityPIXIAPPHorizontal;
    public readonly MenuType : MenuType = MenuType.PlayCityLinkMenu;
    public readonly PanelType: PanelType = PanelType.OnlineResponsive5buttons;
    
	
    public readonly Screens: number = 1;
	public readonly ScreenHeight: ScreenHeightType = 540;
	public readonly ScreenWidth: ScreenWidthType = 960;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DragonJackpot
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	//public readonly ResourcesFolder: string = "./static/online-dragon-960x540/";
    public readonly ResourcesFolder: string = "/frontend-resources/beta/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = false;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = true;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    //public readonly Server: string = "{protocol}//{host}/backend/singlegame";
    ///*Local Server*/ public readonly Server: string = "{protocol}//{hostname}:5006";
    ///*Production Server*/ 
    public readonly Server: string = "{protocol}//{host}";

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "fit";
    public readonly videoFormat = ".mp4";
    public readonly audioFormat = ".mp3";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
}

class Jubilee implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_Online_JubileeLink";

    public readonly ShowLastBigCard: boolean = false;
    public readonly fillingPotFeature: FillingPotFeature = FillingPotFeature.Disable;
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStylePIXI;
    public readonly autoPlaySkipWinLines: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.JubileeLinkResponsivePIXIAPPHorizontal;
    public readonly MenuType : MenuType = MenuType.DummyMenu;
    public readonly PanelType: PanelType = PanelType.OnlineResponsive5buttons1Line;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 1;
	public readonly ScreenHeight: ScreenHeightType = 540;
	public readonly ScreenWidth: ScreenWidthType = 960;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DragonJackpot
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly EnablePanelWithSettings = false;

	//public readonly ResourcesFolder: string = "./static/online-dragon-960x540/";
    public readonly ResourcesFolder: string = "/frontend-resources/beta/";//https://usc1.contabostorage.com/0fe075d87e7e4bb9a28324b884177cb2:resources/staging/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = false;

    public readonly OnlineControls: boolean = true;
    public readonly EndlessFitting: boolean = true;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOutResponsive


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    //public readonly Server: string = "{protocol}//{host}/backend/singlegame";
    ///*Local Server*/ public readonly Server: string = "{protocol}//{hostname}:5006";
    ///*Production Server*/ 
    public readonly Server: string = "{protocol}//{host}";

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "fit";
    public readonly videoFormat = ".mp4";
    public readonly audioFormat = ".mp3";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
}

class Settings_OnlineSignleScreen extends Settings_Online
{
    
    public override readonly SettingsName: string = "Settings_OnlineSignleScreen";
}
class Settings_OnlineDoubleScreen extends Settings_Online
{
    public override readonly SettingsName: string = "Settings_OnlineDoubleScreen";
    public override readonly Screens: number = 2;
    public override readonly ResourcesFolder: string = "./static/online-dragon-960x540-demo/";
    public override readonly PanelType: PanelType = PanelType.Pyramid;
}

class Settings_OnlineDoubleScreenDiamond extends Settings_Online
{
    public override readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.JubileeLink;
    public override readonly SettingsName: string = "Settings_OnlineDoubleScreen_Diamond";
    public override readonly Screens: number = 2;
    public override readonly ResourcesFolder: string = "./static/online-diamond-960x540-demo/";
    public override readonly PanelType: PanelType = PanelType.Pyramid;
}

class Settings_OnlineTrippleScreen extends Settings_Online
{
    public override readonly SettingsName: string = "Settings_OnlineTrippleScreen";
    public override readonly Screens: number = 3;
	public override readonly ScreenHeight: ScreenHeightType = 540;
	public override readonly ScreenWidth: ScreenWidthType = 960;
    public override readonly ResourcesFolder: string = "./static/online-dragon-960x540-demo/";
    public override readonly PanelType: PanelType = PanelType.Pyramid;
}

class Settings_OnlineTrippleScreenDiamond extends Settings_Online
{
    public override readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotJubilee;
    public override readonly SettingsName: string = "Settings_OnlineTrippleScreen_Diamond";
    public override readonly Screens: number = 3;
    public override readonly ResourcesFolder: string = "./static/";
    public override readonly PanelType: PanelType = PanelType.Pyramid;
}

class Settings_Marko implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_Marko";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStep;
    public readonly MenuType: MenuType = MenuType.BigAnimatedMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DragonJackpot
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/resources-original/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = true;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen3;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_Caliente implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName = "Settings_Caliente";
    public readonly ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType = JackpotDisplayType.DiamondPotCaliente;
    public readonly MenuType = MenuType.CalienteMenu;
    public readonly PanelType = PanelType.DefaultBluePanel;
    public readonly Screens = 2;
    public readonly ScreenHeight = 720;
    public readonly ScreenWidth = 1280;
    public readonly Enable2plus1: boolean = false;
    public readonly SourcePick = SourcePickbonus.Ortiz;
    public readonly WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount = DisplayAmount.AsCredits;
    public readonly ResourcesFolder = "/frontend-resources/caliente-720-2s/";
    public readonly SpriteFrameDebugging = false;
    public readonly ConsoleLogging = true;
    public readonly OnlineControls = false;
    public readonly EndlessFitting = false;
    public readonly KeyboardEnabled = true;
    public readonly PresentationType = Presentation.VideoGameSprite;

    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType = VirtualBotoneraType.BigButtons;
    public readonly JackpotSlider = InfoScreenSlider.EnableScreen2;
    public readonly bottoneraFakeSize = { Width: 1360, Height: 768 };
    public readonly bottoneraRealSize = { Width: 1360, Height: 242 };
    public readonly FailOnConnectionLost = true;
    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;
    // public readonly PayoutButtonEnabled = false;
    public readonly touchToStop = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_PlayCityLink3SCurvePanelBottonera implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_PlayCityLink3SCurvePanelBottonera";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.PlayCityLink;
    public readonly MenuType : MenuType = MenuType.PlayCityLinkBigMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotPlayCity;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/playcitylink-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoGameSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen3;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :390 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :390 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_PlayCityLink3SCurveVirtualBottonera implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_PlayCityLink3SCurveVirtualBottonera";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.PlayCityLink;
    public readonly MenuType : MenuType = MenuType.PlayCityLinkBigMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotPlayCity;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/playcitylink-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoGameSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen3;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :390 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :390 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_USA implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_USA";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPot;
    public readonly MenuType : MenuType = MenuType.OrtizMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 608;
	public readonly ScreenWidth: ScreenWidthType = 1080;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/usa-diamond-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = false;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoGameSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen3;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_USARapidLink implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_USA_RapidLink";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RapidDiamondPot;
    public readonly MenuType : MenuType = MenuType.BigAnimatedMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
    
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
    public readonly ScreenHeight: ScreenHeightType = 720;
    public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly ResourcesFolder: string = "/frontend-resources/usa-rapidlink-720-3s/";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoCommonNoSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen3;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = true;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_USARapidLinkBotonera implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_USA_RapidLinkBotonera";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RapidDiamondPot;
    public readonly MenuType : MenuType = MenuType.BigAnimatedMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
    
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
    public readonly ScreenHeight: ScreenHeightType = 720;
    public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly ResourcesFolder: string = "/frontend-resources/usa-rapidlink-720-3s/";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoCommonNoSprite;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen3;
    public readonly bottoneraFakeSize: ISize = { Width : 1024, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1024, Height :768 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = true;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".mp4";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.PurpleStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_USARapidLinkPGA implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_USARapidLinkPGA";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RapidDiamondPot;
    public readonly MenuType : MenuType = MenuType.BigAnimatedMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
    
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
    public readonly ScreenHeight: ScreenHeightType = 720;
    public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly ResourcesFolder: string = "/frontend-resources/usa-rapidlink-720-3s/";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoCommonNoSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen3;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = true;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean =true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_JubileeLink implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_JubileeLink";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.JubileeLink;
    public readonly MenuType : MenuType = MenuType.JubileeMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotJubilee;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/jubileelink-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoGameSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen3;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_JubileeLink_2S implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_JubileeLink";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.JubileeLink;
    public readonly MenuType : MenuType = MenuType.JubileeMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotJubilee;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/jubileelink-720-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoGameSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen2;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_ViventoLink_2S implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_ViventoLink2S";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.ViventoLink;
    public readonly MenuType : MenuType = MenuType.ViventoMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotJubilee;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/viventolink-720-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoGameSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen2;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_ViventoLink_3S implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_ViventoLink3S";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.ViventoLink;
    public readonly MenuType : MenuType = MenuType.ViventoMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/viventolink-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoGameSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen3;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_Quixant_2S implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_Quixant2S";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DragonJackpot;
    public readonly MenuType : MenuType = MenuType.PyramidMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
    
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
    public readonly ScreenHeight: ScreenHeightType = 720;
    public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DragonJackpot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly ResourcesFolder: string = "/frontend-resources/quixant-540-2s/";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.Image;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen2;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquare1MarkeAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_ClassicNoJackpot3S implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_ClassicNoJackpot3S";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.PaytableJackpotDisplay;
    public readonly MenuType : MenuType = MenuType.ClassicMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
    
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
    public readonly ScreenHeight: ScreenHeightType = 720;
    public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotPlayCity;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly ResourcesFolder: string = "/frontend-resources/classic-720-3s2s/";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoCommonClassic;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquare1MarkeAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.GameTitleJackpot;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable    
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_ClassicNoJackpot2S implements ISettings, DoubleUpMiscellaneous, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_ClassicNoJackpot2S";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.PaytableJackpotDisplay;
    public readonly MenuType : MenuType = MenuType.ClassicMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
    
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
    public readonly ScreenHeight: ScreenHeightType = 720;
    public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotPlayCity;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly ResourcesFolder: string ="/frontend-resources/classic-720-3s2s/";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoCommonClassic;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquare1MarkeAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.GameTitleJackpot;  
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable  
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_ClassicNoJackpot2Sdreidel implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_ClassicNoJackpot2S";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.PaytableJackpotDisplay;
    public readonly MenuType : MenuType = MenuType.ClassicMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
    public readonly Screens: number = 2;
    public readonly Enable2plus1: boolean = false;
    public readonly ScreenHeight: ScreenHeightType = 720;
    public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotPlayCity;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly ResourcesFolder: string = "/frontend-resources/classic-720-2s/";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoCommonClassic;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquare1MarkeAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.GameTitleJackpot;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable    
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_ClassicFreeGames implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_ClassicFreeGames";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPot
    public readonly MenuType : MenuType = MenuType.OrtizMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 1080;
	public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/resources-original/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoGameSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = true;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}


class Settings_Firenze implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_Firenze";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStep
    public readonly MenuType : MenuType = MenuType.OrtizMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/firenze-720-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoGameSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen2;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_Tornado32 implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_Tornado32";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStep
    public readonly MenuType : MenuType = MenuType.OrtizMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/Tornado32-720-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoGameSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen2;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_AutlanRapidLink implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_Autlan_RapidLink";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RapidDiamondPot;
    public readonly MenuType : MenuType = MenuType.BigAnimatedMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/autlan-rapidlink-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoCommonNoSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen3;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = true;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_AutlanDiamondPot implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_Autlan_DiamondPot";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPot;
    public readonly MenuType : MenuType = MenuType.OrtizMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/autlan-diamondpot-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = false;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoGameSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen3;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean =true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_Colombia implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_Colombia";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStep;
    public readonly MenuType : MenuType = MenuType.BigAnimatedMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/colombia-720-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoGameSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen2;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly videoFormat = ".webm";
    public readonly DefaultFitType: FitType = "none";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_Eternal implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_Eternal";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RapidDiamondPot;
    public readonly MenuType : MenuType = MenuType.EternalFortuneMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 1080;
	public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/test-eternalfortune-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoCommonNoSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen3;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_RapidLinkFire2S implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_RapidLinkFire2S";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RapidDiamondPotStep
    public readonly MenuType : MenuType = MenuType.BigAnimatedMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/rapidlinkfire-720-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoCommonNoSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen2;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_RapidLinkFire2SVirtualBotonera implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_RapidLinkFire2SVirtualBotonera";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RapidDiamondPotStep
    public readonly MenuType : MenuType = MenuType.BigAnimatedMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/rapidlinkfire-720-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoCommonNoSprite;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen2;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_RapidLinkFire3S implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_RapidLinkFire3S";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RapidDiamondPotStep;
    public readonly MenuType : MenuType = MenuType.OrtizMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/rapidlinkfire-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoCommonNoSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen3;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_RapidLinkMysticMenu3S implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_RapidLinkMysticMenu3S";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RapidDiamondPotFire;
    public readonly MenuType : MenuType = MenuType.MysticMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/rapidlinkMystic-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoCommonNoSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen3;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_RapidLinkBigMysticMenu3S implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_RapidLinkBigMysticMenu3S";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RapidDiamondPotFire;
    public readonly MenuType : MenuType = MenuType.BigAnimatedMysticMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/rapidlinkBigMystic-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoCommonNoSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen3;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_RapidLinkBigAsianMenu3S implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_RapidLinkBigAsianMenu3S";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RapidDiamondPotFire;
    public readonly MenuType : MenuType = MenuType.BigAnimatedAsianMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/rapidlinkBigAsian-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoCommonNoSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen3;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_Tequila implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_Tequila";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DragonJackpot;
    public readonly MenuType : MenuType = MenuType.OrtizMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/tequila-dragonlink-720-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoGameSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen2;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_SanIgnacioDiamondPotStep implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_SanIgnacioDiamondPotStep";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStep
    public readonly MenuType : MenuType = MenuType.OrtizMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/sanignacio-720-2s/";// "/frontend-resources/firenze-720-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoGameSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen2;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_RapidLinkBigMysticMenu3SCurve implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_RapidLinkBigMysticMenu3SCurve";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RapidDiamondPotFire;
    public readonly MenuType : MenuType = MenuType.MysticMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/rapidlinkMystic-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoCommonNoSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen3;    
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :390 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :390 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_Trinidad implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_Trinidad";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStep;
    public readonly MenuType: MenuType = MenuType.BigAnimatedMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DragonJackpot
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/trinidad-720-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoGameSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen2;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FirenzePGA implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FirenzePGA";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPot;
    public readonly MenuType : MenuType = MenuType.BigAnimatedMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/firenze-pga-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = false;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoGameSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen3;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean =true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_ApatzinganDreidel implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_ApatzinganDreidel";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStep
    public readonly MenuType : MenuType = MenuType.BigAnimatedMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/apatzingan-720-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoGameSprite;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen2;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_BigAnimatedMenuDiamondPot implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_BigAnimatedMenuDiamondPot";
    
    public readonly ShowLastBigCard: boolean = false;
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPot;
    public readonly MenuType : MenuType = MenuType.BigAnimatedMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/biganimatedmenu-diamondpot-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = false;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoGameSprite;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen3;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean =true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_RapindLinkBigMenu2S implements ISettings {
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_RapindLinkBigMenu2S";
    
    public readonly ShowLastBigCard: boolean = false;
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RapidDiamondPotStep;
    public readonly MenuType: MenuType = MenuType.BigAnimatedMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
    
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
    public readonly ScreenHeight: ScreenHeightType = 720;
    public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;

    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly ResourcesFolder: string = "/frontend-resources/rapidlinkbigmenu-720-2s/";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType: Presentation = Presentation.VideoCommonNoSprite;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen2;
    public readonly bottoneraFakeSize: ISize = { Width: 1360, Height: 768 };
    public readonly bottoneraRealSize: ISize = { Width: 1360, Height: 242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop: boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType: WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage = "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_RumaniaLink3s implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_RumaniaLink3s";
    
    public readonly ShowLastBigCard: boolean = false;
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RapidDiamondPot;
    public readonly MenuType : MenuType = MenuType.BigAnimatedMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/rumanialink-720-3s2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = false;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoCommonNoSprite;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen3;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean =true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_RumaniaLink2s implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_RumaniaLink2s";
    
    public readonly ShowLastBigCard: boolean = false;
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RapidDiamondPotStep;
    public readonly MenuType : MenuType = MenuType.BigAnimatedMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/rumanialink-720-3s2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = false;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoCommonNoSprite;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen2;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean =true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_USARapidLink1080 implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_USA_RapidLink1080";
    
    public readonly ShowLastBigCard: boolean = false;
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RapidDiamondPot;
    public readonly MenuType : MenuType = MenuType.BigAnimatedMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
    
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
    public readonly ScreenHeight: ScreenHeightType = 1080;
    public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly ResourcesFolder: string = "/frontend-resources/usa-rapidlink-1080-3s/";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoCommonNoSprite;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen3;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = true;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_ClassicNoJackpot2S_1080 implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_ClassicNoJackpot2S_1080";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.PaytableJackpotDisplay;
    public readonly MenuType : MenuType = MenuType.ClassicMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
    
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
    public readonly ScreenHeight: ScreenHeightType = 1080;
    public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotPlayCity;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly ResourcesFolder: string ="/frontend-resources/classic-1080-3s2s/";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoCommonClassic;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5006/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquare1MarkeAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.GameTitleJackpot;    
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_PurpleDiamondPot implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_PurpleDiamondPot";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPot;
    public readonly MenuType : MenuType = MenuType.BigAnimatedMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/purple-diamondpot-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = false;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoGameSprite;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen3;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean =true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_PurpleDiamondPot_PP implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_PurpleDiamondPot_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPot;
    public readonly MenuType : MenuType = MenuType.BigAnimatedMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/purple-diamondpot-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = false;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoGameSprite;
    public readonly EnablePanelWithSettings = true

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen3;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean =true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_PurpleFirenze implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_PurpleFirenze";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStep
    public readonly MenuType : MenuType = MenuType.BigAnimatedMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/purple-firenze-720-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoGameSprite;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen2;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_PurpleFirenze_PP implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_PurpleFirenze_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStep
    public readonly MenuType : MenuType = MenuType.BigAnimatedMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/purple-firenze-720-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoGameSprite;
    public readonly EnablePanelWithSettings = true

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen2;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_RapidLinkPGA implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_RapidLinkPGA";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RapidDiamondPot;
    public readonly MenuType : MenuType = MenuType.BigAnimatedMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/rapidlink-pga-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = false;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoCommonNoSprite;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen3;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean =true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_RapidLinkPGA_PP implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_RapidLinkPGA_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RapidDiamondPot;
    public readonly MenuType : MenuType = MenuType.BigAnimatedMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/rapidlink-pga-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = false;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoCommonNoSprite;
    public readonly EnablePanelWithSettings = true

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen3;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean =true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_SingleGameDiamondPotStep implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_SingleGameDiamondPotStep";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStep
    public readonly MenuType : MenuType = MenuType.BigAnimatedMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/singlegame-720-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoGameSprite;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen2;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_SingleGameDiamondPotStep_PP implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_SingleGameDiamondPotStep_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStep
    public readonly MenuType : MenuType = MenuType.BigAnimatedMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/singlegame-720-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoGameSprite;
    public readonly EnablePanelWithSettings = true

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.EnableScreen2;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Disable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot1080 implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotRappidFrames;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 1080;
	public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources-original/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot_2s1080 implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotRappidFrames;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 1080;
	public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-1080-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot_2s1080_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot_2s1080_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotRappidFrames;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 1080;
	public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-1080-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot720 implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot";
    public readonly ShowLastBigCard: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotRappidFrames;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot720_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot_PP";
    public readonly ShowLastBigCard: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotRappidFrames;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot720_Botonera720 implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot";
    public readonly ShowLastBigCard: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotRappidFrames;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 720 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot720_Botonera720_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot_PP";
    public readonly ShowLastBigCard: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotRappidFrames;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 720 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot_DiamondPot_2S_720 implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPotDiamondPot2S720";
    public readonly ShowLastBigCard: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStep;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-720-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot_DiamondPot_2S_720_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPotDiamondPot2S720_PP";
    public readonly ShowLastBigCard: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStep;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-720-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot_DiamondPot_3S_720_2p1 implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot_DiamondPot_3S_720_2p1";
    public readonly ShowLastBigCard: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepRappidFrames;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = true;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-720-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot_DiamondPot_3S_720_2p1_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot_DiamondPot_3S_720_2p1_PP";
    public readonly ShowLastBigCard: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepRappidFrames;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = true;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-720-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot_DiamondPot_3S_720_Bottonera720 implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPotDiamondPot2S720";
    public readonly ShowLastBigCard: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStep;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 720 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot_DiamondPot_3S_720_Bottonera720_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPotDiamondPot2S720_PP";
    public readonly ShowLastBigCard: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStep;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 720 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot_DiamondPot_2S_1080 implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot_DiamondPot2S_1080";
    public readonly ShowLastBigCard: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStep;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 1080;
	public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-1080-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot_DiamondPot_2S_1080_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot_DiamondPot2S_1080_PP";
    public readonly ShowLastBigCard: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStep;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 1080;
	public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-1080-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot_SingleGame_DiamondPot_2S_720 implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot_SingleGame_DiamondPot_2S_720";
    public readonly ShowLastBigCard: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStep;
    public readonly MenuType: MenuType = MenuType.DummyMenu;
    public readonly PanelType: PanelType = PanelType.BluePanelSingleGame;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-720-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot_SingleGame_DiamondPot_2S_720_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot_SingleGame_DiamondPot_2S_720_PP";
    public readonly ShowLastBigCard: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStep;
    public readonly MenuType: MenuType = MenuType.DummyMenu;
    public readonly PanelType: PanelType = PanelType.BluePanelSingleGame;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-720-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot_SingleGame_DiamondPot_2S_1080 implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot_SingleGame_DiamondPot_2S_1080";
    public readonly ShowLastBigCard: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStep;
    public readonly MenuType: MenuType = MenuType.DummyMenu;
    public readonly PanelType: PanelType = PanelType.BluePanelSingleGame;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 1080;
	public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-1080-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot_SingleGame_DiamondPot_2S_1080_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot_SingleGame_DiamondPot_2S_1080_PP";
    public readonly ShowLastBigCard: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStep;
    public readonly MenuType: MenuType = MenuType.DummyMenu;
    public readonly PanelType: PanelType = PanelType.BluePanelSingleGame;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 1080;
	public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-1080-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = false;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot720VirtualBotonera implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot";
    public readonly ShowLastBigCard: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotRappidFrames;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :390 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :390 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot720VirtualBotonera_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot_PP";
    public readonly ShowLastBigCard: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotRappidFrames;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :390 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :390 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPotDiamondPotStepShared720VirtualBotonera_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPotShared_PP";
    public readonly ShowLastBigCard: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpot-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :390 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :390 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPotDiamondPotStepNoShared720VirtualBotonera_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPotNoShared_PP";
    public readonly ShowLastBigCard: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepSinShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpot-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :390 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :390 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot_DiamondPot_2S_1080_VirtualBotonera implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot720_2ScreensVirtualBotonera";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStep
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 1080;
	public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-1080-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot_DiamondPot_2S_1080_VirtualBotonera_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot720_2ScreensVirtualBotonera_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStep
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 1080;
	public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-1080-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot_DiamondPot_2S_720_VirtualBotonera implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot_DiamondPot_2S_720_VirtualBotonera";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStep
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-720-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot_DiamondPot_2S_720_VirtualBotonera_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot_DiamondPot_2S_720_VirtualBotonera_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStep
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-720-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_RapidLinkFillingPot3s_1080 implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_USARapidLinkFillingPot3s_1080";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RapidDiamondPot2;
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
    
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
    public readonly ScreenHeight: ScreenHeightType = 1080;
    public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-1080-3s/";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = true;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean =true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_RapidLinkFillingPot3s_1080_PP implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_USARapidLinkFillingPot3s_1080_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RapidDiamondPot2;
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
    
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
    public readonly ScreenHeight: ScreenHeightType = 1080;
    public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-1080-3s/";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = true;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean =true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_RapidLinkFillingPot2s_1080 implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_USARapidLinkFillingPot2s_1080";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RapidDiamondPotStep2;
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
    
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
    public readonly ScreenHeight: ScreenHeightType = 1080;
    public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-1080-2s/";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = true;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean =true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_RapidLinkFillingPot2s_1080_PP implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_USARapidLinkFillingPot2s_1080_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RapidDiamondPotStep2;
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
    
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
    public readonly ScreenHeight: ScreenHeightType = 1080;
    public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-1080-2s/";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = true;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean =true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_RapidLinkFillingPot3s_720 implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_USARapidLinkFillingPot3s_720";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RapidDiamondPot2;
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
    
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
    public readonly ScreenHeight: ScreenHeightType = 720;
    public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-720-3s/";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionMatterJS;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = true;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".mp4";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean =true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_RapidLinkFillingPot3s_720_PP implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_USARapidLinkFillingPot3s_720_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RapidDiamondPot2;
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
    
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
    public readonly ScreenHeight: ScreenHeightType = 720;
    public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-720-3s/";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionMatterJS;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = true;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".mp4";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean =true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_RapidLinkFillingPot2s_720 implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_RapidLinkFillingPot2s_720";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RapidDiamondPotStep2;
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
    
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
    public readonly ScreenHeight: ScreenHeightType = 720;
    public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-720-2s/";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = true;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".mp4";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean =true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_RapidLinkFillingPot2s_720_PP implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_RapidLinkFillingPot2s_720_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RapidDiamondPotStep2;
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
    
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
    public readonly ScreenHeight: ScreenHeightType = 720;
    public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-720-2s/";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = true;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".mp4";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean =true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot_DiamondPotStepRappidFrames2s_1080 implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot_DiamondPotStepRappidFrames2s_1080";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepRappidFrames;
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
    
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
    public readonly ScreenHeight: ScreenHeightType = 720;
    public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-1080-2s";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = true;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean =true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot_DiamondPotStepRappidFrames2s_1080_PP implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot_DiamondPotStepRappidFrames2s_1080_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepRappidFrames;
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
    
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
    public readonly ScreenHeight: ScreenHeightType = 720;
    public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-1080-2s";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = true;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean =true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot_DiamondPotStepRappidFrames2s_720 implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot_DiamondPotStepRappidFrames2s_720";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepRappidFrames;
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
    
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
    public readonly ScreenHeight: ScreenHeightType = 720;
    public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-720-2s/";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = true;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean =true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot_DiamondPotStepRappidFrames2s_720_PP implements ISettings, DoubleUpMiscellaneous
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot_DiamondPotStepRappidFrames2s_720_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepRappidFrames;
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
    
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
    public readonly ScreenHeight: ScreenHeightType = 720;
    public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-720-2s/";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = true;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean =true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot720_3s_Ideck implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot720_3s_Ideck";
    public readonly ShowLastBigCard: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotRappidFrames;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1024, Height: 768 };
    public readonly bottoneraRealSize: ISize = { Width: 1024, Height: 768 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot720_3s_Ideck_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot720_3s_Ideck_PP";
    public readonly ShowLastBigCard: boolean = false;
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotRappidFrames;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-720-3s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1024, Height: 768 };
    public readonly bottoneraRealSize: ISize = { Width: 1024, Height: 768 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_RainbowGirls3s_720 implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_RainbowGirls3s_720";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RainbowGirls;
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
    
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
    public readonly ScreenHeight: ScreenHeightType = 720;
    public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly ResourcesFolder: string = "/frontend-resources-original/";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = true;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean =true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_RainbowGirls3s_720_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_RainbowGirls3s_720_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RainbowGirls;
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
    
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
    public readonly ScreenHeight: ScreenHeightType = 720;
    public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly ResourcesFolder: string = "/frontend-resources-original/";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = true;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean =true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_RainbowGirls3s_1080 implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_RainbowGirls3s_1080";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RainbowGirls;
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
    
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
    public readonly ScreenHeight: ScreenHeightType = 1080;
    public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly ResourcesFolder: string = "/frontend-resources-original/";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = true;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean =true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_RainbowGirls3s_1080_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_RainbowGirls3s_1080_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.RainbowGirls;
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultBluePanel;
    
    
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
    public readonly ScreenHeight: ScreenHeightType = 1080;
    public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPotCaliente;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

    public readonly ResourcesFolder: string = "/frontend-resources-original/";
    public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1280, Height :720 };
    public readonly bottoneraRealSize: ISize = { Width : 1280, Height :242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = false;
    public readonly titleGameSlide: boolean = true;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean =true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot_DiamondPotStepRappidFrames2s_1080_VirtualBotonera implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot_DiamondPotStepRappidFrames2s_1080_VirtualBotonera";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepRappidFrames
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 1080;
	public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-1080-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot_DiamondPotStepRappidFrames2s_720_VirtualBotonera implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot_DiamondPotStepRappidFrames2s_720_VirtualBotonera";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepRappidFrames
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-720-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot_DiamondPotStepRappidFrames2s_720_VirtualBotonera_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot_DiamondPotStepRappidFrames2s_720_VirtualBotonera_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepRappidFrames
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/fillingPot-720-2s/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot1080_DiamondPotStepShared2Plus1 implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot1080_DiamondPotStepShared2Plus1";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = true;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 1080;
	public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpot-shared-1080-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot720_DiamondPotStepShared2Plus1 implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot720_DiamondPotStepShared2Plus1";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = true;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpot-shared-720-2s-3s-2p1/"
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot720_DiamondPotStepShared2Plus1_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot720_DiamondPotStepShared2Plus1_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = true;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpot-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot1080_DiamondPotStepShared implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot1080_DiamondPotStepShared";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 1080;
	public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpot-shared-1080-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot1080_DiamondPotStepShared_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot1080_DiamondPotStepShared_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 1080;
	public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources-prepared/diamondpot-shared-1080-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot720_DiamondPotStepShared implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot720_DiamondPotStepShared";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpot-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot720_DiamondPotStepShared_Curva implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot720_DiamondPotStepShared_Curva";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 608;
	public readonly ScreenWidth: ScreenWidthType = 1080;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpot-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot720_DiamondPotStepShared_VirtualBotonera implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot720_DiamondPotStepShared_VirtualBotonera";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpot-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1024, Height: 768 };
    public readonly bottoneraRealSize: ISize = { Width: 1024, Height: 768 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot720_DiamondPotStepShared_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot720_DiamondPotStepShared_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpot-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot720_2s_DiamondPotStepShared implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot720_DiamondPotStepShared";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources-prepared/diamondpot-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot720_2s_DiamondPotStepShared_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot720_DiamondPotStepShared_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources-prepared/diamondpot-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot720_DiamondPotStepNoShared implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot720_DiamondPotStepNoShared";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepSinShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpot-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
    
}


class Settings_FillingPot2s720_DiamondPotStepNoShared_VirtualBotonera implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot720_DiamondPotStepNoShared_VirtualBotonera";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepSinShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpot-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1024, Height: 768 };
    public readonly bottoneraRealSize: ISize = { Width: 1024, Height: 768 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
    
}

class Settings_FillingPot2s720_DiamondPotStepNoShared implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot720_DiamondPotStepNoShared";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepSinShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpot-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1024, Height: 768 };
    public readonly bottoneraRealSize: ISize = { Width: 1024, Height: 768 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
    
}
class Settings_FillingPot720_DiamondPotStepNoShared2p1 implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot720_DiamondPotStepNoShared2p1";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepSinShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = true;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpot-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot720_DiamondPotStepNoShared2p1_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot720_DiamondPotStepNoShared2p1_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepSinShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = true;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpot-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot720_DiamondPotStepNoShared_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot720_DiamondPotStepNoShared_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepSinShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpot-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot1080_DiamondPotStepNoShared implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot1080_DiamondPotStepNoShared";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepSinShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpot-shared-1080-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot1080_DiamondPotStepNoShared_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot1080_DiamondPotStepNoShared_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepSinShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 1080;
	public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpot-shared-1080-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot1080_DiamondPotStepNoShared2p1 implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot1080_DiamondPotStepNoShared2p1";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepSinShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = true;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 1080;
	public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpot-shared-1080-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot1080_DiamondPotStepNoShared2p1_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot1080_DiamondPotStepNoShared2p1_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepSinShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = true;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 1080;
	public readonly ScreenWidth: ScreenWidthType = 1920;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpot-shared-1080-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;


    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot720_DiamondPotStepShared_VirtualBotonera_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot720_DiamondPotStepShared_VirtualBotonera_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepShared
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string =  "/frontend-resources/diamondpot-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot720_DiamondPotPyramidShared_VirtualBotonera_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot720_DiamondPotPyramidShared_VirtualBotonera_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotPyramidShared
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string =  "/frontend-resources/diamondpotpyramid-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot720_DiamondPotPyramidsinShared_VirtualBotonera_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot720_DiamondPotPyramidsinShared_VirtualBotonera_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotPyramidShared
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string =  "/frontend-resources/diamondpotpyramid-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot2s720_DiamondPotStepNoShared_VirtualBotonera_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot720_DiamondPotStepNoShared_VirtualBotonera_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepSinShared
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string =  "/frontend-resources/diamondpot-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.BigButtons;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}


class Settings_FillingPot2s720_DiamondPotStepNoShared_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot720_DiamondPotStepNoShared_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotStepSinShared
    public readonly MenuType : MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel;
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.ViventoLink;
    public readonly WallDisplayScreens: number = 1;

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string =  "/frontend-resources/diamondpot-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;
    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Enable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraRealSize: ISize = { Width : 1360, Height :242 };
    public readonly WallDisplaySize: ISize = { Width: 1280, Height: 720 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = true;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations;
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}


//Settings New Jackpot 
class Settings_FillingPot3S_720_DiamondPotPyramidShared implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot3S_720_DiamondPotPyramidShared";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotPyramidShared;
    public readonly MenuType: MenuType = MenuType.InGameMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpotpyramid-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot3S_720_DiamondPotPyramidSinShared implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot3S_720_DiamondPotPyramidSinShared";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotPyramidSinShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpotpyramid-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot2S_720_DiamondPotPyramidShared implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot2S_720_DiamondPotPyramidShared";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotPyramidShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpotpyramid-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot2S_720_DiamondPotPyramidSinShared implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot2S_720_DiamondPotPyramidSinShared";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotPyramidSinShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpotpyramid-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

//2lus1Settings
class Settings_FillingPot3S_720_DiamondPotPyramidShared2p1 implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot3S_720_DiamondPotPyramidShared2p1";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotPyramidShared;
    public readonly MenuType: MenuType = MenuType.InGameMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = true;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpotpyramid-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot3S_720_DiamondPotPyramidSinShared2p1 implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot3S_720_DiamondPotPyramidSinShared2p1";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotPyramidSinShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = true;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpotpyramid-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

//Settings PP
class Settings_FillingPot3S_720_DiamondPotPyramidShared_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot3S_720_DiamondPotPyramidShared_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotPyramidShared;
    public readonly MenuType: MenuType = MenuType.InGameMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpotpyramid-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}


class Settings_FillingPot2S_720_DiamondPotPyramidShared2S_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot2S_720_DiamondPotPyramidShared2S_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotPyramidShared2S;
    public readonly MenuType: MenuType = MenuType.InGameMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpotpyramid-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot2S_720_DiamondPotPyramidSinShared2S_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot2S_720_DiamondPotPyramidSinShared2S_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotPyramidShared2S;
    public readonly MenuType: MenuType = MenuType.InGameMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpotpyramid-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot2S_720_DiamondPotPyramidJP4SharedJP3SinShared2S_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot2S_720_DiamondPotPyramidJP4SharedJP3SinShared2S_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotPyramidJP4SharedJP3SinShared2S;
    public readonly MenuType: MenuType = MenuType.InGameMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpotpyramid-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

class Settings_FillingPot3S_720_DiamondPotPyramidSinShared_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot3S_720_DiamondPotPyramidSinShared_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotPyramidSinShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpotpyramid-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot2S_720_DiamondPotPyramidShared_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot2S_720_DiamondPotPyramidShared_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotPyramidShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpotpyramid-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot2S_720_DiamondPotPyramidSinShared_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot2S_720_DiamondPotPyramidSinShared_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotPyramidSinShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 2;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpotpyramid-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

//2lus1Settings-PP
class Settings_FillingPot3S_720_DiamondPotPyramidShared2p1_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot3S_720_DiamondPotPyramidShared2p1_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotPyramidShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = true;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpotpyramid-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}
class Settings_FillingPot3S_720_DiamondPotPyramidSinShared2p1_PP implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot3S_720_DiamondPotPyramidSinShared2p1_PP";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotPyramidSinShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = true;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpotpyramid-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = true;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

//JP4Share JP3SinShare
class Settings_FillingPot720_DiamondPotPyramidJP4ShareJP3SinShared implements ISettings
{
    public readonly PauseBackgroundSound: boolean = true;
    public readonly ShowMinBetInfo: boolean = false;
    public readonly ShowLastBigCard: boolean = false;
    public readonly SettingsName: string = "Settings_FillingPot720_DiamondPotPyramidJP4ShareJP3SinShared";
    
    public readonly ScreenConfiguration: ScreenConfiguration = ScreenConfiguration.CombinedScreen;
    public readonly JackpotDisplayType: JackpotDisplayType = JackpotDisplayType.DiamondPotPyramidJP4ShareJP3SinShared;
    public readonly MenuType: MenuType = MenuType.ScrollingMenu;
    public readonly PanelType: PanelType = PanelType.DefaultGameColorPanel
    
	
    public readonly Enable2plus1: boolean = false;
    public readonly Screens: number = 3;
	public readonly ScreenHeight: ScreenHeightType = 720;
	public readonly ScreenWidth: ScreenWidthType = 1280;
    public readonly SourcePick: SourcePickbonus = SourcePickbonus.Ortiz;
    
    public readonly WallDisplayType: WallDisplayType = WallDisplayType.DiamondPot;
    public readonly WallDisplayScreens: number = 1;
    public readonly WallDisplaySize: ISize = { Width: 1920, Height: 1080 };

    public readonly DisplayAmount: DisplayAmount = DisplayAmount.AsCredits;

	public readonly ResourcesFolder: string = "/frontend-resources/diamondpotpyramid-shared-720-2s-3s-2p1/";
	public readonly SpriteFrameDebugging: boolean = false;
    public readonly ConsoleLogging: boolean = true;

    public readonly OnlineControls: boolean = false;
    public readonly EndlessFitting: boolean = false;
    public readonly KeyboardEnabled: boolean = true;
    public readonly PresentationType : Presentation = Presentation.VideoParticleTransitionFadeInFadeOut;
    public readonly EnablePanelWithSettings = false;

    public readonly JackpotDisplay: JackpotDisplay = JackpotDisplay.Disable;
    public readonly VirtualBotoneraType: VirtualBotoneraType = VirtualBotoneraType.Disable;

    public readonly JackpotSlider: InfoScreenSlider = InfoScreenSlider.Disable;
    //public readonly bottoneraFakeSize: ISize = { Width : 1360, Height :768 };
    public readonly bottoneraFakeSize: ISize = { Width: 1280, Height: 242 };
    public readonly bottoneraRealSize: ISize = { Width: 1280, Height: 242 };

    public readonly FailOnConnectionLost: boolean = true;

    public readonly Server: () => string = () => (new URLSearchParams(window.location.search))?.get("server") ?? `${location.hostname}:5005/ws`;

    // public readonly PayoutButtonEnabled : boolean = false;
    public readonly touchToStop : boolean = true;
    public readonly titleGameSlide: boolean = false;
    public readonly winLinesType : WinLinesType = WinLinesType.WinSquareAnimations
    public readonly DefaultFitType: FitType = "none";
    public readonly videoFormat = ".webm";
    public readonly audioFormat = ".ogg";
    public readonly warningMessage: WarningMessage= "malfunction";
    public readonly skipCommet: boolean = true;
    public readonly screen3Display: Screen3SettingDisplay = Screen3SettingDisplay.JackpotDisplay;
    public readonly fillingPotFeature : FillingPotFeature = FillingPotFeature.Enable;
    public readonly menuGameSelectPresentation: boolean = true;
    public readonly cometStyle: CometStyles = CometStyles.BlueStyle;
    public readonly autoPlaySkipWinLines : boolean = false;
}

//End New Settings Jackpot 
export class SettingsFactory
{
    public constructor()
    {

    }
    // protected PlayCityLimit: string[] = ["PlayCityHighLimit", "PlayCityNormalLimit"]
    // protected JubileeLimit: string[]= ["JubileeHighLimit", "JubileeNormalLimit"]
    

    public CreateSettings(settingsName = null): ISettings
    {
        const urlParams = new URLSearchParams(window.location.search);
        let settings: ISettings;
        let requestedSettings = settingsName ?? urlParams?.get("settings");

        // if (!requestedSettings)
        // {
        //     throw "No settings name provided to settings factory";
        // }
       
        //let getGameName = urlParams?.get("gameName") ?? urlParams.get("gameCode");

        



        //let onlineLimit = getGameName.slice(0, this.PlayCityLimit.find(x => getGameName.includes(x))?.length); 

        // if (getGameName.slice(0, this.PlayCityLimit.find(x => getGameName.includes(x))?.length)){
        //     isPlayCityOnlineGame = true
        // }
        // else if (getGameName.slice(0, this.JubileeLimit.find(x => getGameName.includes(x))?.length))
        // {
        //     isJubileeOnlineGame = true
        // }

        if (requestedSettings == "online-1s")
        {
            settings = new Settings_OnlineSignleScreen();
        }
        else if (requestedSettings == "online")
        {
            settings = new Settings_Online();
        }
        else if (requestedSettings == "DiamondPot")
        {
            settings = new DiamondPot();
        }
        else if (requestedSettings == "MultiBonus")
        {
            settings = new MultiBonus();
        }
        else if (requestedSettings == "FillingPot")
        {
            settings = new FillingPot();
        }
         else if (requestedSettings == "RapidLink")
        {
            settings = new RapidLink();
        }
        else if (requestedSettings == "Jubilee")
        {
            settings = new Jubilee();
        }
        else if (requestedSettings == "PlayCity")
        {
            settings = new PlayCity();
        }
        else if (requestedSettings == "PlayCityMultiBonus")
        {
            settings = new PlayCityMultiBonus();
        }
        else if (requestedSettings == "Classic")
        {
            settings = new Classic();
        }
        else if (requestedSettings == "onlineclassic")
        {
            settings = new Classic();
        }
        else if (requestedSettings == "online-2s")
        {
            settings = new Settings_OnlineDoubleScreen();
        }
        else if (requestedSettings == "online-3s")
        {
            settings = new Settings_OnlineTrippleScreen();
        }
        else if (requestedSettings == "online-2s-diamondpot")
        {
            settings = new Settings_OnlineDoubleScreenDiamond();
        }
        else if (requestedSettings == "online-3s-diamondpot")
        {
            settings = new Settings_OnlineTrippleScreenDiamond();
        }
        else if (requestedSettings == "marko")
        {
            settings = new Settings_Marko();
        }
        else if (requestedSettings == "caliente")
        {
            settings = new Settings_Caliente();
        }
        else if (requestedSettings == "playcitylink3spanel")
        {
            settings = new Settings_PlayCityLink3SCurvePanelBottonera();
        }
        else if (requestedSettings == "playcitylink3svirtual")
        {
            settings = new Settings_PlayCityLink3SCurveVirtualBottonera();
        }
        else if (requestedSettings == "usa")
        {
            settings = new Settings_USA();
        }
        else if (requestedSettings == "usa2")
        {
            settings = new Settings_USARapidLink();
        }
        else if (requestedSettings == "usa2botonera")
        {
            settings = new Settings_USARapidLinkBotonera();
        }
        else if (requestedSettings == "usa2pga")
        {
            settings = new Settings_USARapidLinkPGA();
        }
        else if (requestedSettings == "jubileelink")
        {
            settings = new Settings_JubileeLink();
        }
        else if (requestedSettings == "jubileelink2s")
        {
            settings = new Settings_JubileeLink_2S();
        }
        else if (requestedSettings == "viventolink2s")
        {
            settings = new Settings_ViventoLink_2S();
        }
        else if (requestedSettings == "viventolink3s")
        {
            settings = new Settings_ViventoLink_3S();
        }
        else if (requestedSettings == "quixant")
        {
            settings = new Settings_Quixant_2S();
        }
        else if (requestedSettings == "classic3s")
        {
            settings = new Settings_ClassicNoJackpot3S();
        }
        else if (requestedSettings == "classic2s")
        {
            settings = new Settings_ClassicNoJackpot2S();
        }
        else if (requestedSettings == "classic2sdrei")
        {
            settings = new Settings_ClassicNoJackpot2Sdreidel();
        }
        else if (requestedSettings == "classicfreegame")
        {
            settings = new Settings_ClassicFreeGames();
        }else if(requestedSettings == "firenze")
        {
            settings = new Settings_Firenze();
        }else if(requestedSettings == "tornado32")
        {
            settings = new Settings_Tornado32();
        }
        else if(requestedSettings == "autlanrap")
        {
            settings = new Settings_AutlanRapidLink();
        }
        else if(requestedSettings == "autlandia")
        {
            settings = new Settings_AutlanDiamondPot();
        }
        else if(requestedSettings == "colombia")
        {
            settings = new Settings_Colombia();
        }
        else if(requestedSettings == "eternal")
        {
            settings = new Settings_Eternal();
        }
        else if(requestedSettings == "rapidfire2s")
        {
            settings = new Settings_RapidLinkFire2S();
        }
        else if(requestedSettings == "rapidfire2s-virtualbotonera")
        {
            settings = new Settings_RapidLinkFire2SVirtualBotonera();
        }
        else if(requestedSettings == "rapidfire3s")
        {
            settings = new Settings_RapidLinkFire3S();
        }
        else if(requestedSettings == "rapidmystic")
        {

            settings = new Settings_RapidLinkMysticMenu3S();
        }
        else if (requestedSettings == "rapidbigmystic")
        {
            settings = new Settings_RapidLinkBigMysticMenu3S();
        }
        else if (requestedSettings == "rapidbigasian")
        {
            settings = new Settings_RapidLinkBigAsianMenu3S();
        }
        else if (requestedSettings == "tequila")
        {
            settings = new Settings_Tequila();
        }
        else if (requestedSettings == "rapidbigmysticcurve")
        {
            settings = new Settings_RapidLinkBigMysticMenu3SCurve();
        }
        else if (requestedSettings == "sanignaciodia")
        {
            settings = new Settings_SanIgnacioDiamondPotStep();
        }
        else if (requestedSettings == "trinidad")
        {
            settings = new Settings_Trinidad();
        }
        else if (requestedSettings == "firenzepga")
        {
            settings = new Settings_FirenzePGA();
        }
        else if (requestedSettings == "apatzingandreidel")
        {
            settings = new Settings_ApatzinganDreidel();
        }
        else if (requestedSettings == "bigmenudiamondpot")
        {
            settings = new Settings_BigAnimatedMenuDiamondPot();
        }
        else if (requestedSettings == "bigmenurapid2s")
        {
            settings = new Settings_RapindLinkBigMenu2S();
        }
        else if (requestedSettings == "rumanialink3s")
        {
            settings = new Settings_RumaniaLink3s();
        }
        else if (requestedSettings == "rumanialink2s")
        {
            settings = new Settings_RumaniaLink2s();
        }
        else if (requestedSettings == "usa1080")
        {
            settings = new Settings_USARapidLink1080();
        }
        else if (requestedSettings == "fillingpot3s-1080")
        {
            settings = new Settings_FillingPot1080();
        }
        else if (requestedSettings == "fillingpot3s-720")
        {
            settings = new Settings_FillingPot720();
        }
        else if (requestedSettings == "fillingpot3s-720-pp")
        {
            settings = new Settings_FillingPot720_PP();
        }
        else if (requestedSettings == "fillingpotdiamond3s-720-2p1")
        {
            settings = new Settings_FillingPot_DiamondPot_3S_720_2p1();
        }
        else if (requestedSettings == "fillingpotdiamond3s-720-2p1-pp")
        {
            settings = new Settings_FillingPot_DiamondPot_3S_720_2p1_PP();
        }
        else if (requestedSettings == "fillingpotrainbowgirls3s-1080")
        {
            settings = new Settings_RainbowGirls3s_1080();
        }
        else if (requestedSettings == "fillingpotrainbowgirls3s-1080-pp")
        {
            settings = new Settings_RainbowGirls3s_1080_PP();
        }
        else if (requestedSettings == "fillingpotrainbowgirls3s-720")
        {
            settings = new Settings_RainbowGirls3s_720();
        }
        else if (requestedSettings == "fillingpotrainbowgirls3s-720-pp")
        {
            settings = new Settings_RainbowGirls3s_720_PP();
        }
        else if (requestedSettings == "fillingpot-2s1080")
        {
            settings = new Settings_FillingPot_2s1080();
        }
        else if (requestedSettings == "fillingpot-2s1080-pp")
        {
            settings = new Settings_FillingPot_2s1080_PP();
        }
        else if (requestedSettings == "fillingpot3s-720-botonera720")
        {
            settings = new Settings_FillingPot720_Botonera720();
        }
        else if (requestedSettings == "fillingpot3s-720-botonera720")
        {
            settings = new Settings_FillingPot720_Botonera720_PP();
        }
        else if (requestedSettings == "fillingpotdiamond2s-720")
        {
            settings = new Settings_FillingPot_DiamondPot_2S_720();
        }
        else if (requestedSettings == "fillingpotdiamond2s-720-pp")
        {
            settings = new Settings_FillingPot_DiamondPot_2S_720_PP();
        }
        else if (requestedSettings == "fillingpotdiamond3s-720-botonera720")
        {
            settings = new Settings_FillingPot_DiamondPot_3S_720_Bottonera720();
        }
        else if (requestedSettings == "fillingpotdiamond3s-720-botonera720-pp")
        {
            settings = new Settings_FillingPot_DiamondPot_3S_720_Bottonera720_PP();
        }
        else if (requestedSettings == "fillingpotdiamond2s-1080")
        {
            settings = new Settings_FillingPot_DiamondPot_2S_1080();
        }
        else if (requestedSettings == "fillingpotdiamond2s-1080-pp")
        {
            settings = new Settings_FillingPot_DiamondPot_2S_1080_PP();
        }
        else if (requestedSettings == "fillingpotdiamond2s-720-virtualbotonera")
        {
            settings = new Settings_FillingPot_DiamondPot_2S_720_VirtualBotonera();
        }
        else if (requestedSettings == "fillingpotdiamond2s-720-virtualbotonera-pp")
        {
            settings = new Settings_FillingPot_DiamondPot_2S_720_VirtualBotonera_PP();
        }
        else if (requestedSettings == "fillingpotdiamond2s-1080-virtualbotonera")
        {
            settings = new Settings_FillingPot_DiamondPot_2S_1080_VirtualBotonera();
        }
        else if (requestedSettings == "fillingpotdiamond2s-1080-virtualbotonera-pp")
        {
            settings = new Settings_FillingPot_DiamondPot_2S_1080_VirtualBotonera_PP();
        }
        else if (requestedSettings == "fillingpotsinglediamond2s-720")
        {
            settings = new Settings_FillingPot_SingleGame_DiamondPot_2S_720();
        }
        else if (requestedSettings == "fillingpotsinglediamond2s-720-pp")
        {
            settings = new Settings_FillingPot_SingleGame_DiamondPot_2S_720_PP();
        }
        else if (requestedSettings == "fillingpotsinglediamond2s-1080")
        {
            settings = new Settings_FillingPot_SingleGame_DiamondPot_2S_1080();
        }
        else if (requestedSettings == "fillingpotsinglediamond2s-1080-pp")
        {
            settings = new Settings_FillingPot_SingleGame_DiamondPot_2S_1080_PP();
        }
        else if (requestedSettings == "fillingpot3s-720-virtualbotonera")
        {
            settings = new Settings_FillingPot720VirtualBotonera();
        }  
        else if (requestedSettings == "fillingpot3s-720-virtualbotonera-pp")
        {
            settings = new Settings_FillingPot720VirtualBotonera_PP();
        }  
        else if (requestedSettings == "fillingpot3s-720-virtualbotonera-shared-pp")
        {
            settings = new Settings_FillingPotDiamondPotStepShared720VirtualBotonera_PP();
        }  
        else if (requestedSettings == "fillingpot3s-720-virtualbotonera-noshared-pp")
        {
            settings = new Settings_FillingPotDiamondPotStepNoShared720VirtualBotonera_PP();
        }  
        else if (requestedSettings == "fillingpot3s1080-rapidlink")
        {
            settings = new Settings_RapidLinkFillingPot3s_1080();
        }
        else if (requestedSettings == "fillingpot3s1080-rapidlink-pp")
        {
            settings = new Settings_RapidLinkFillingPot3s_1080_PP();
        }   
        else if (requestedSettings == "fillingpot2s1080-rapidlink")
        {
            settings = new Settings_RapidLinkFillingPot2s_1080();
        } 
        else if (requestedSettings == "fillingpot2s1080-rapidlink-pp")
        {
            settings = new Settings_RapidLinkFillingPot2s_1080_PP();
        }
        else if (requestedSettings == "fillingpot3s720-rapidlink")
        {
            settings = new Settings_RapidLinkFillingPot3s_720();
        }  
        else if (requestedSettings == "fillingpot3s720-rapidlink-pp")
        {
            settings = new Settings_RapidLinkFillingPot3s_720_PP();
        } 
        else if (requestedSettings == "fillingpot2s720-rapidlink")
        {
            settings = new Settings_RapidLinkFillingPot2s_720();
        }    
        else if (requestedSettings == "fillingpot2s720-rapidlink-pp")
        {
            settings = new Settings_RapidLinkFillingPot2s_720_PP();
        } 
        else if (requestedSettings == "fillingpot2s1080-diamondpotsteprapidframes")
        {
            settings = new Settings_FillingPot_DiamondPotStepRappidFrames2s_1080();
        }
        else if (requestedSettings == "fillingpot2s1080-diamondpotsteprapidframes-pp")
        {
            settings = new Settings_FillingPot_DiamondPotStepRappidFrames2s_1080_PP();
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotsteprapidframes")
        {
            settings = new Settings_FillingPot_DiamondPotStepRappidFrames2s_720();
        }     
        else if (requestedSettings == "fillingpot2s720-diamondpotsteprapidframes-pp")
        {
            settings = new Settings_FillingPot_DiamondPotStepRappidFrames2s_720_PP();
        }    
        else if (requestedSettings == "fillingpot2s1080-diamondpotsteprapidframes-virtualbotonera")
        {
            settings = new Settings_FillingPot_DiamondPotStepRappidFrames2s_1080_VirtualBotonera();
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotsteprapidframes-virtualbotonera")
        {
            settings = new Settings_FillingPot_DiamondPotStepRappidFrames2s_720_VirtualBotonera();
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotsteprapidframes-virtualbotonera-pp")
        {
            settings = new Settings_FillingPot_DiamondPotStepRappidFrames2s_720_VirtualBotonera_PP();
        }
        else if(requestedSettings == "fillingpot3s-720-Ideck")
        {
            settings = new Settings_FillingPot720_3s_Ideck();
        }
        else if(requestedSettings == "fillingpot3s-720-Ideck-pp")
        {
            settings = new Settings_FillingPot720_3s_Ideck_PP();
        } 
        else if (requestedSettings == "fillingpot3s1080-diamondpotstepshared2plus1") {
            settings = new Settings_FillingPot1080_DiamondPotStepShared2Plus1();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotstepshared2plus1") {
            settings = new Settings_FillingPot720_DiamondPotStepShared2Plus1();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotstepshared2plus1-pp")
        {
            settings = new Settings_FillingPot720_DiamondPotStepShared2Plus1_PP();
        }
        else if (requestedSettings == "fillingpot3s1080-diamondpotstepshared") {
            settings = new Settings_FillingPot1080_DiamondPotStepShared();
        }
        else if (requestedSettings == "fillingpot3s1080-diamondpotstepshared-pp") {
            settings = new Settings_FillingPot1080_DiamondPotStepShared_PP();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotstepshared") {
            settings = new Settings_FillingPot720_DiamondPotStepShared();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotstepshared-curva") {
            settings = new Settings_FillingPot720_DiamondPotStepShared_Curva();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotstepshared-virtualbotonera") {
            settings = new Settings_FillingPot720_DiamondPotStepShared_VirtualBotonera();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotstepshared-pp") {
            settings = new Settings_FillingPot720_DiamondPotStepShared_PP();
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotstepshared") {
            settings = new Settings_FillingPot720_2s_DiamondPotStepShared();
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotstepshared-pp")
        {
            settings = new Settings_FillingPot720_2s_DiamondPotStepShared_PP
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotstepnoshared")
        {
            settings = new Settings_FillingPot720_DiamondPotStepNoShared();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotstepnoshared2p1")
        {
            settings = new Settings_FillingPot720_DiamondPotStepNoShared2p1();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotstepnoshared2p1-pp")
        {
            settings = new Settings_FillingPot720_DiamondPotStepNoShared2p1_PP();
        }
        else if (requestedSettings == "fillingpot3s1080-diamondpotstepnoshared2p1")
        {
            settings = new Settings_FillingPot1080_DiamondPotStepNoShared2p1();
        }
        else if (requestedSettings == "fillingpot3s1080-diamondpotstepnoshared2p1-pp")
        {
            settings = new Settings_FillingPot1080_DiamondPotStepNoShared2p1_PP();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotstepnoshared-pp")
        {
            settings = new Settings_FillingPot720_DiamondPotStepNoShared_PP()
        }
        else if (requestedSettings == "fillingpot3s1080-diamondpotstepnoshared")
        {
            settings = new Settings_FillingPot1080_DiamondPotStepNoShared()
        }
        else if (requestedSettings == "fillingpot3s1080-diamondpotstepnoshared-pp")
        {
            settings = new Settings_FillingPot1080_DiamondPotStepNoShared_PP()
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotstepshared-virtualbotonera-pp")
        {
            settings = new  Settings_FillingPot720_DiamondPotStepShared_VirtualBotonera_PP()
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotstepnoshared-virtualbotonera")
        {
            settings = new  Settings_FillingPot2s720_DiamondPotStepNoShared_VirtualBotonera()
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotstepnoshared-virtualbotonera-pp")
        {
            settings = new  Settings_FillingPot2s720_DiamondPotStepNoShared_VirtualBotonera_PP()
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotstepnoshared")
        {
            settings = new  Settings_FillingPot2s720_DiamondPotStepNoShared()
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotstepnoshared-pp")
        {
            settings = new  Settings_FillingPot2s720_DiamondPotStepNoShared_PP()
        }

        //New Jackpot Settings 
        else if (requestedSettings == "fillingpot3s720-diamondpotpyramidshare") {
            settings = new Settings_FillingPot3S_720_DiamondPotPyramidShared();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotpyramidsinshare") {
            settings = new Settings_FillingPot3S_720_DiamondPotPyramidSinShared();
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotpyramidshare") {
            settings = new Settings_FillingPot2S_720_DiamondPotPyramidShared();
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotpyramidsinshare") {
            settings = new Settings_FillingPot2S_720_DiamondPotPyramidSinShared();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotpyramidjp4sharejp3sinshare") {
            settings = new  Settings_FillingPot720_DiamondPotPyramidJP4ShareJP3SinShared();
        }   
        else if (requestedSettings == "fillingpot3s720-diamondpotpyramidshare-pp") {
            settings = new Settings_FillingPot3S_720_DiamondPotPyramidShared_PP();
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotpyramidshare2s-pp") {
            settings = new Settings_FillingPot2S_720_DiamondPotPyramidShared2S_PP();
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotpyramidsinshare2s-pp") {
            settings = new Settings_FillingPot2S_720_DiamondPotPyramidSinShared2S_PP();
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotpyramidjp4sharejp3sinshare2s-pp") {
            settings = new Settings_FillingPot2S_720_DiamondPotPyramidJP4SharedJP3SinShared2S_PP();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotpyramidsinshare-pp") {
            settings = new Settings_FillingPot3S_720_DiamondPotPyramidSinShared_PP();
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotpyramidshare-pp") {
            settings = new Settings_FillingPot2S_720_DiamondPotPyramidShared_PP();
        }
        else if (requestedSettings == "fillingpot2s720-diamondpotpyramidsinshare-pp") {
            settings = new Settings_FillingPot2S_720_DiamondPotPyramidSinShared_PP();
        }      
        //Settings2P1 
        else if (requestedSettings == "fillingpot3s720-diamondpotpyramidshare2p1") {
            settings = new Settings_FillingPot3S_720_DiamondPotPyramidShared2p1();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotpyramidsinshare2p1") {
            settings = new Settings_FillingPot3S_720_DiamondPotPyramidSinShared2p1();
        }        
        //Settings2p1-PP        
        else if (requestedSettings == "fillingpot3s720-diamondpotpyramidshare2p1-pp") {
            settings = new Settings_FillingPot3S_720_DiamondPotPyramidShared2p1_PP();
        }
        else if (requestedSettings == "fillingpot3s720-diamondpotpyramidsinshare2p1-pp") {
            settings = new Settings_FillingPot3S_720_DiamondPotPyramidSinShared2p1_PP();
        } 
        //virtualbotonera
        else if (requestedSettings == "Settings_FillingPot720_DiamondPotPyramidShared_VirtualBotonera_PP")
        {
            settings = new  Settings_FillingPot720_DiamondPotPyramidShared_VirtualBotonera_PP()
        }
        //End New Jackpot Settings    
        else if (requestedSettings == "classic2s1080")
        {
            settings = new Settings_ClassicNoJackpot2S_1080();
        }
        else if (requestedSettings == "purplediamondpot")
        {
            settings = new Settings_PurpleDiamondPot();
        }
        else if (requestedSettings == "purplediamondpot-pp")
        {
            settings = new Settings_PurpleDiamondPot_PP();
        }
        else if (requestedSettings == "purplefirenze")
        {
            settings = new Settings_PurpleFirenze();
        }
        else if (requestedSettings == "purplefirenze-pp")
        {
            settings = new Settings_PurpleFirenze_PP();
        }
        else if (requestedSettings == "rapidlinkpga")
        {
            settings = new Settings_RapidLinkPGA();
        }
        else if (requestedSettings == "rapidlinkpga-pp")
        {
            settings = new Settings_RapidLinkPGA_PP();
        }
        else if (requestedSettings == "singlegame")
        {
            settings = new Settings_SingleGameDiamondPotStep();
        }
        else if (requestedSettings == "singlegame-pp")
        {
            settings = new Settings_SingleGameDiamondPotStep_PP();
        }
        else if (requestedSettings === undefined || requestedSettings === null)
        {
            settings = new Classic();
        }
        // else
        // {
        //     assertNever(`Unimplemented settings ${requestedSettings}`);
        // }
        

        console.log("CreateSettings()", settings);

        return settings;
    }
}

// export class Settings
// {
//     protected static instance: ISettings = new SettingsFactory().CreateSettings();
//     public static get Instance(): ISettings
//     {
//         return Settings.instance;
//     }
// }

export const FruitGames: string[] = [
    "BurningFruits20",
    "BurningFruits40",
    "BurningFruits5",
    "FireBlastClassic",
    "FireBlastDeluxClassic",
    "IceBlastDeluxClassic",
    "IceBlast",
    "LuckyFire100",
    "LuckyFire10",
    "LuckyFire20",
    "LuckyFire40Delux",
    "LuckyFire40",
    "LuckyFire5",
    "LuckyIce100",
    "LuckyIce10",
    "LuckyIce20",
    "LuckyIce40Delux",
    "LuckyIce40",
    "LuckyIce5",
    "RoyalChalice",
    "RoyalDice",
    "RoyalKingDeluxe",
    "RoyalKing",
    "ShiningChalice",
    "StickyChilliClassic",
    "TikiBayClassic",
    "WildChalice",

]

let settingsFactory: SettingsFactory = new SettingsFactory();
export let Settings = settingsFactory.CreateSettings();

export function ChangeSettings(settingsName: string)
{
    console.log("Changing settings to " + settingsName);
    Settings = settingsFactory.CreateSettings(settingsName);
}


//export const MonitorScreenWidth : number = 1080;
//export const MonitorScreenHeight : number =  1920;
